/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyJobExecutionTypeQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("PolicyJobExecutionTypeQueryOperator");
    }

    getFixupPrototypeFunction() { return PolicyJobExecutionTypeQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<PolicyJobExecutionTypeQueryOperator>): PolicyJobExecutionTypeQueryOperator {
        let obj = Object.assign(new PolicyJobExecutionTypeQueryOperator(), model);
        PolicyJobExecutionTypeQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyJobExecutionTypeQueryOperator>): PolicyJobExecutionTypeQueryOperator {
        if (!model) return null;
        return PolicyJobExecutionTypeQueryOperator.newInstance(<PolicyJobExecutionTypeQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyJobExecutionTypeQueryOperator) {
        if (!obj) return;

        models.PolicyJobExecutionTypeQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyJobExecutionTypeQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, PolicyJobExecutionTypeQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Policy job execution types to include
     */
    execution_types: Array<models.PolicyJobExecutionType>;

}
